export var ScrollToTop = function (_a) {
    var history = _a.history;
    if (history.action === 'PUSH') {
        window.scrollTo(0, 0);
    }
    // tslint:disable-next-line:no-null-keyword
    return null;
};
//# sourceMappingURL=index.js.map